export class Config {
  constructor(json: any = {}) {
    Object.assign(this, json);
  }

  urlPath: string;
  types: string;
  limit: number;
}
